import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_COMPLEX_STEP_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestComplexNext($data: SvbrgIntakeRequestComplexInput!) {
    sevenbridges {
      chatSession {
        request {
          requestNextComplex(data: $data) {
            id
            accountingAreaId
            commodityGroupId
            currency
            budget
            organizationId
            deliveryLocationId
            lineItems {
              id
              sequence
              position
              title
              description
              quantity
              expectedPricePerUnit
              unitId
              earlyDeliveryAt
              lateDeliveryAt
            }
          }
        }
      }
    }
  }
`);
